export default "__VITE_ASSET__1bca4923__"